import {useEffect, useState} from "react";
import {ITenantContext, ITenantContextState} from "./TenantContext.interfaces";
import UserSettingsApi from "../../apis/userSettingsApi";
import {ITeamsContext} from "../TeamsContext/TeamsContext.interfaces";

const defaultConfiguration: ITenantContextState = {
    loaded: false,
    enableCopilot: false,
    enableWindows: false,
    enableGpt: false
};

export const useTenantContext = (teamsContext: ITeamsContext): ITenantContext => {
    const [state, setState] = useState<ITenantContextState>(defaultConfiguration);

    useEffect(function onMount() {
        if (!teamsContext.loaded) return;
        initialize().then();
    }, [teamsContext.loaded])

    const initialize = async () => {
        const data = await UserSettingsApi.getTenantSettings(teamsContext.tenantId);
        setState({
            loaded: true,
            enableCopilot: data.copilot,
            enableWindows: data.windowsApp,
            //DEBUG
            enableGpt: true //data.gpt
        });
    }

    return state;
}